export default function(to, from, savedPosition) {
  const nuxt = window.$nuxt;

  // TODO find a way to take this from the appURLs constant in utils/route-redirects.ts:38
  // TODO this must be in sync with the appURLs constant
  // NOTE: from the limited time provided to work on this ticket SKD-1581 Feedback point 33, I've not been able to get this module to do imports from other parts of our code function to do imports in this module
  /**
   * A map of routes to scroll restoration behaviors
   * @type {Record<string, 'auto' | 'instant' | 'smooth'>}
   * @description
   * This map is used to define the scroll restoration behavior for each route.
   * The key is the name of the route, and the value is the behavior to use.
   * The behavior can be one of the following:
   * - 'auto': The browser will determine the behavior
   * - 'instant': The scroll will be instant
   * - 'smooth': The scroll will be smooth
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior
   */
  const scrollRestorationMap = {
    index: 'instant',
    markets: 'instant',
    'profile-profileId': 'instant'
  };

  // TODO find a way to import this from utils/routeNames.ts:13
  // NOTE: same remark as above applies
  // NOTE: this is copied over from utils/routeNames.ts:13
  /**
   * Removes the localization suffix from a route. Useful for checking which route the user is on in a localized nuxt app.
   * @param {NuxtRoute} route The route the user is currently on
   * @returns {string | undefined} The unlocalized route name
   */
  function unlocalizeRouteName(route) {
    // nuxt route names will have the name of the route in the following format
    // <route_name>__<locale>
    const localeSplitRoute = route.name?.split('__') ?? [];

    // in normal operation of the app, there will be two parts once the route name is split.
    // if there are more than two parts, one of the developers has given a poor name to the route.
    // this should be reported.
    if (localeSplitRoute.length > 2) {
      console.error(
        'This app does not support route names with double underscores. Rename your route',
        { route }
      );
    }

    // the name of the route without the locale at the end
    const unlocalizedRouteName = localeSplitRoute[0];

    return unlocalizedRouteName;
  }

  return new Promise((resolve) => {
    nuxt.$once('triggerScroll', () => {
      // 0 - same-page & same-hash => no scroll
      if (to.name === from.name && to.hash === from.hash) {
        return resolve(false);
      }

      const unlocalizedTo = unlocalizeRouteName(to);

      const behavior =
      unlocalizedTo in scrollRestorationMap ?
      scrollRestorationMap[unlocalizedTo] :
      'smooth';

      // 1 - back/forward with savedPosition
      if (savedPosition) {
        console.debug('scrollBehavior with savedPosition', {
          to: to.fullPath,
          from: from.fullPath,
          savedPosition
        });

        const targetY = savedPosition.y ?? 0;

        const attemptScroll = (tries = 0) => {
          const maxScroll =
          document.documentElement.scrollHeight - window.innerHeight;

          // If content is tall enough OR we've tried enough times, resolve now
          if (targetY <= maxScroll || tries >= 10) {
            console.debug('scrollBehavior applying position', {
              targetY,
              maxScroll,
              tries
            });

            return resolve({
              x: savedPosition.x || 0,
              y: targetY,
              behavior
            });
          }

          // Otherwise wait a bit and see if content got taller
          requestAnimationFrame(() => attemptScroll(tries + 1));
        };

        return attemptScroll();
      }

      // 2 - hash-based scrolling
      if (to.hash) {
        return resolve({
          selector: to.hash,
          behavior
        });
      }

      // 3 - default behavior for "normal" navigations
      return resolve({
        x: 0,
        y: 0,
        behavior
      });
    });
  });
}
